import { Box, BoxProps } from "@mui/material";

const CompletedStatusAnimation = (props: BoxProps) => {
  return (
    <Box
      component="object"
      type="image/svg+xml"
      data="/svg/completed-status.svg"
      {...props}
      sx={{
        width: 100,
        ...props.sx,
      }}
    >
      Completed Status Animation
    </Box>
  );
};

export { CompletedStatusAnimation };
